import { createTheme } from '@mui/material';

import config from './config.json';

const theme = createTheme({ palette: config.palette });

export default theme;
